// extracted by mini-css-extract-plugin
export default {"wrapper":"TextArea-module__wrapper___JYTiZ"};